





































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { State, Getter, Action, Mutation } from '../store-helper'
import AnswerItem from '../../../common/AnswerItem'
import { IAnswerItem, IQuestion } from '../../../types'
import { IAnswer } from '../types'
import { getGroupQuestion, checkAnsweredGroup, checkBlankGroupQuestion } from '../../../lib/group-question'

@Component({})
export default class QuestionListComponent extends Vue {
  @State questions: IQuestion<IAnswerItem>[]
  @State answers: IAnswer[]
  @Action changeQuestion
  @Action submit
  @Getter totalQuestionGroup: number

  constructor() {
    super()
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        let elm = <Element>window.document.querySelector('#questionList')
        let height = window.innerHeight - elm.getBoundingClientRect().top
        elm.setAttribute('style', 'height: ' + height + 'px')
      })
      let elm = <Element>window.document.querySelector('#questionList')
      let height = window.innerHeight - elm.getBoundingClientRect().top
      elm.setAttribute('style', 'height: ' + height + 'px')
    })
  }

  public get groupQuestions(): IQuestion<IAnswerItem>[][] {
    return getGroupQuestion(this.questions)
  }

  public checkAnswered(question: IQuestion<IAnswerItem>): boolean {
    let answer = this.answers.find((answer) => answer.q_id == question.id)
    return answer && answer.body ? true : false
  }

  public isBlankGroupQuestion(questions: IQuestion<IAnswerItem>[]): boolean {
    return checkBlankGroupQuestion(questions)
  }
}
